const apiUrl = process.env.REACT_APP_API_URL;

export const applicationConfig = {
  API_URL: apiUrl,
};
